import { render } from "./LndAbout.vue?vue&type=template&id=732a34cc&lang=pug"
import script from "./LndAbout.vue?vue&type=script&lang=js"
export * from "./LndAbout.vue?vue&type=script&lang=js"

import "./LndAbout.vue?vue&type=style&index=0&id=732a34cc&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__